// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5236":"f1828abe","7577":"f1828abe"}[chunkId] + ".chunk.css";
};